import type { BillingPreviewUI } from "@/domain/billing/billing-preview.model"
import type { PricingNextSavingsHint, PricingPreviewView } from "@/domain/pricing/pricing-preview.model"

/**
 * Maps authoritative billing preview totals into {@link PricingPreviewView}.
 * `nextSavings` is attached by the caller (selector), not inferred here.
 *
 * Customer savings come only from `savingsSummary.totalSavings` (never from `totalDiscount`).
 */
export function mapBillingPreviewToPricingView(
  ui: BillingPreviewUI,
  nextSavings: PricingNextSavingsHint | null
): PricingPreviewView {
  return {
    subtotal: ui.subTotal,
    total: ui.payableAmount,
    totalSavings: ui.savingsSummary?.totalSavings ?? 0,
    totalDiscount: ui.totalDiscount,
    taxes: ui.totalTax,
    fees: ui.totalFees,
    nextSavings,
    source: ui,
  }
}
